export default __webpack_public_path__ + "static/media/new_motionCoin1.ef3d80d4.png";